import { render, staticRenderFns } from "./NativeAd.vue?vue&type=template&id=7a5965c4"
import script from "./NativeAd.vue?vue&type=script&lang=js"
export * from "./NativeAd.vue?vue&type=script&lang=js"
import style0 from "./NativeAd.vue?vue&type=style&index=0&id=7a5965c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports